import React, { useState, ChangeEvent } from 'react';
import styled from 'styled-components';
import { themes } from 'kb-shared';
import gql from 'graphql-tag';
import { PatientPharmacyResponseData } from 'kb-shared/graphql/types';
import { useMutation } from 'react-apollo';

import { FieldsRow, Icon, Text, InputsLabel } from './shared';
import TextInput, { Container } from 'components/TextInput/NewTextInput';
import { pharmacy } from 'assets/icons';
import { showErrorToast } from 'utilities/notificationUtils';
import { patientQuery } from 'components/Dashboard/ProfileWidget';

export const UPDATE_PATIENT_PHARMACY = gql`
  mutation updatePatientPharmacy($name: String, $phone: String) {
    updatePatientPharmacy(name: $name, phone: $phone) {
      patientPharmacy {
        phone
        name
      }
    }
  }
`;

type Props = {
  pharmacyName?: string;
  phone?: string;
};

export default function PharmacyFields({ pharmacyName, phone }: Props) {
  const [pharmacyDetails, setPharmacyDetails] = useState({ name: pharmacyName, phone });
  const [updatePharmacyDetails] = useMutation<PatientPharmacyResponseData>(
    UPDATE_PATIENT_PHARMACY,
    {
      refetchQueries: [{ query: patientQuery }]
    }
  );
  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    setPharmacyDetails({
      ...pharmacyDetails,
      [e.target.name]: e.target.value
    });
  };
  const updatePharmacy = () => {
    updatePharmacyDetails({
      variables: {
        ...pharmacyDetails
      }
    }).catch(res => {
      // @ts-ignore
      const errors = res.graphQLErrors.map(error => {
        return JSON.parse(error.message);
      });
      const errorCopy = errors[0].join(', ');
      return showErrorToast(errorCopy);
    });
  };

  return (
    <>
      <FieldsRow>
        <InputsLabel>
          <Icon src={pharmacy} />
          <Text>Prescriptions will be sent here</Text>
        </InputsLabel>
        <InputRow>
          <TextInput
            name="name"
            label="PHARMACY NAME"
            value={pharmacyDetails.name}
            onChange={handleChange}
            // @ts-ignore
            onBlur={updatePharmacy}
          />
          <TextInput
            name="phone"
            inputType="phone"
            autoComplete="tel"
            label="TELEPHONE NUMBER"
            value={pharmacyDetails.phone}
            onChange={handleChange}
            // @ts-ignore
            onBlur={updatePharmacy}
          />
        </InputRow>
      </FieldsRow>
    </>
  );
}

const InputRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  width: 100%;

  ${Container} {
    margin-right: 20px;
    width: 50%;
  }

  @media screen and (max-width: ${themes.breakpoints.tabletPortrait}) {
    flex-direction: column;

    ${Container} {
      width: 100%;
    }
  }
`;
